export default "__VITE_ASSET__b6$CP8dq__"